// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13iMu","requiredAsterisk":"Info_requiredAsterisk__2Q-Ed"};